'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _is_js = _interopRequireDefault(require("is_js"));
var _AddDepartmentModal = _interopRequireDefault(require("Modals/AddDepartmentModal"));
var _DeleteDepartmentModal = _interopRequireDefault(require("Modals/DeleteDepartmentModal"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _getStateFromObject = _interopRequireDefault(require("Components/Forms/Functions/getStateFromObject"));
var _getFormData = _interopRequireDefault(require("Components/Forms/Functions/getFormData"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
class SectorForm extends _react.Component {
  state = {
    loading: false,
    status_messages: {},
    'sector[department]': [],
    openAddDepartmentModal: false,
    openDeleteDepartmentModal: false
  };
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (props.type === 'update') {
      component.fetchSector();
    }
  }
  fetchSector = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post('/sector/get-all', {
      id: props.id || document.location.pathname.split('/configuration/liste-des-secteurs/')[1],
      with_count: false
    }).then(function (xhr, response) {
      const department = response.sectors[0].department;
      delete response.sectors[0].department;
      const update = (0, _getStateFromObject.default)({
        data: response.sectors[0],
        model: 'sector'
      });
      component.setState({
        ...update,
        'sector[department]': department,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const sector = (0, _getFormData.default)({
      state: state,
      pattern: 'sector['
    });
    const url = props.type === 'update' ? '/sector/update' : '/sector/create';
    qwest.post(url, sector).then(function (xhr, response) {
      if (props.type === 'update') {
        component.fetchSector();
      } else {
        component.clearForm();
        window.setTimeout(function () {
          app.navigateTo('/configuration/liste-des-secteurs');
        }, 2000);
      }
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('sector[')).reduce(function (update, key) {
      console.log(state[key], _is_js.default.string(state[key]));
      if (_is_js.default.string(state[key])) {
        update[key] = '';
      } else if (_is_js.default.array(state[key])) {
        update[key] = [];
      } else if (_is_js.default.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  deleteDepartment = department_to_delete => {
    const component = this,
      props = this.props,
      state = this.state;
    const department_filtered = state['sector[department]'].filter(function (department) {
      return department !== department_to_delete;
    });
    component.setState({
      'sector[department]': department_filtered
    });
  };
  openAddDepartmentModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openAddDepartmentModal: true,
      add_modal_trigger: e.target
    });
  };
  closeAddDepartmentModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openAddDepartmentModal: false,
      add_modal_trigger: undefined
    });
  };
  openDeleteDepartmentModal = ({
    department,
    e
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    e.persist();
    component.setState({
      openDeleteDepartmentModal: true,
      delete_modal_department: department,
      delete_modal_trigger: e.target
    });
  };
  closeDeleteDepartmentModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      openDeleteDepartmentModal: false,
      delete_modal_date: undefined,
      delete_modal_trigger: undefined
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    const department_list = (state['sector[department]'] || []).map(function (department, index) {
      let output = /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        sm: 2,
        classes: props.classes,
        key: index
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "u-margin-left-5 u-margin-right-5 u-margin-top-15 u-margin-bottom-5"
      }, department, /*#__PURE__*/_react.default.createElement(_Button.default, {
        color: "secondary",
        variant: "contained",
        size: "small",
        onClick: e => component.openDeleteDepartmentModal({
          department,
          e
        }),
        className: "u-margin-left-5 u-margin-right-5"
      }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/sector/create"
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['sector[name]'],
      name: "sector[name]",
      type: "text",
      label: "Nom du secteur",
      status: state.status_messages
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 6,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "button",
      color: "primary",
      variant: "contained",
      size: "large",
      className: "u-margin-left-15",
      onClick: e => component.openAddDepartmentModal(e)
    }, "Ajouter un d\xE9partement", loader)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      item: true,
      xs: 12,
      sm: 12,
      classes: props.classes
    }, /*#__PURE__*/_react.default.createElement("p", null, "Liste des d\xE9partements li\xE9s \xE0 ce secteur :"), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 3,
      classes: props.classes
    }, department_list)), /*#__PURE__*/_react.default.createElement(_AddDepartmentModal.default, {
      department: state['sector[department]'],
      open: state.openAddDepartmentModal,
      onClose: component.closeAddDepartmentModal,
      add_modal_trigger: state.add_modal_trigger
    }), /*#__PURE__*/_react.default.createElement(_DeleteDepartmentModal.default, {
      deleteDepartmentFunc: component.deleteDepartment,
      department_to_delete: state.delete_modal_department,
      open: state.openDeleteDepartmentModal,
      onClose: component.closeDeleteDepartmentModal,
      delete_modal_trigger: state.delete_modal_trigger
    })), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-50 u-padding-bottom-20 u-text-center"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "primary",
      variant: "contained",
      size: "large",
      onClick: component.validate
    }, props.type === 'update' ? 'Mettre à jour' : 'Créer ce secteur', loader)));
    return output;
  }
}
exports.default = SectorForm;
